/** Aviso del sorteo → resultados de ESE sorteo (Eduardo 2026-10-05).
 *
 * El servidor manda `draw_results_url` solo en los avisos del sorteo cuyo
 * sorteo sigue registrado (/player/tournaments/<id>/sorteo?division=<id>).
 * Solo se aceptan rutas internas del jugador; cualquier otra cosa se ignora y
 * el aviso queda como texto normal. */
export function drawResultsPath(url: string | null | undefined): string | null {
  return typeof url === "string" && url.startsWith("/player/") ? url : null;
}

/** Categoría pedida por la liga de los resultados del sorteo (?division=). */
export function divisionFromSearch(search: URLSearchParams): number | null {
  const raw = search.get("division");
  if (raw == null || raw.trim() === "") return null;
  const value = Number(raw);
  return Number.isInteger(value) && value > 0 ? value : null;
}
